import qs from 'qs';
export function getBookingEngineUrl({ bookingEngineUrl, hotelId, roomId, showHotel, startDate, endDate, promotionCode, version = 1, rooms = [
    {
        adults: 2,
        children: 0,
    },
], }) {
    const hasHotel = showHotel && hotelId;
    const queryString = qs.stringify(Object.assign(Object.assign(Object.assign({ checkIn: startDate, checkOut: endDate, rooms }, promotionCode && { pc: promotionCode }), roomId && { roomId }), { utm_source: 'WEB', utm_medium: 'CHATBOT' }), { arrayFormat: 'indices', allowDots: true, encodeValuesOnly: true });
    const result = `rooms?${queryString}`;
    return hasHotel ? `${bookingEngineUrl}/${hotelId}/${result}` : `${bookingEngineUrl}/${result}`;
}
